import { render, staticRenderFns } from "./AddUpdateFilemanagerFolder.vue?vue&type=template&id=6ba6bb4a&"
import script from "./AddUpdateFilemanagerFolder.vue?vue&type=script&lang=js&"
export * from "./AddUpdateFilemanagerFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports